import { render, staticRenderFns } from "./MitraInfo.vue?vue&type=template&id=51857fa4&"
import script from "./MitraInfo.vue?vue&type=script&lang=js&"
export * from "./MitraInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports